import SmartRoute from './SmartRoute'

export default SmartRoute
